import { FilterList } from "@mui/icons-material";
import {
  Badge,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Modal,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function GlobalInventoryFilter({
  height,
  width,
  thickness,
  setHeight,
  setWidth,
  setThicknesss,
  setFilter,
}) {
  const resetFilters = () => {
    setHeight("");
    setWidth("");
    setThicknesss("");
  };
  const [count, setCount] = useState(0);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFilter(true);
  };

  useEffect(() => {
    let totalCount = 0;
    if (height) {
      totalCount++;
    }
    if (width) {
      totalCount++;
    }
    if (thickness) {
      totalCount++;
    }

    setCount(totalCount);
  }, [height, width, thickness]);

  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>

        {/* <IconButton onClick={handleOpen} aria-label="Filters" size="large">
          <FilterList />
        </IconButton> */}
      </Tooltip>
      <Modal open={open} onClose={handleClose}>
        <Card sx={style} style={{ width: "500px" }}>
          <CardContent>
            <Paper>
              <Grid container spacing={5}>
                <Grid item xs={12} md={4} lg={4}>
                  <TextField
                    label="Height"
                    fullWidth
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <TextField
                    label="Width"
                    fullWidth
                    value={width}
                    onChange={(e) => setWidth(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <TextField
                    label="Thickness"
                    fullWidth
                    value={thickness}
                    onChange={(e) => setThicknesss(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <Button onClick={resetFilters} color="error">
                    Reset All Filter
                  </Button>
                </Grid>
                <Grid
                  container
                  justifyContent={"flex-end"}
                  item
                  xs={12}
                  md={6}
                  lg={6}
                >
                  <Button
                    onClick={() => {
                      handleClose();
                      setFilter(true);
                    }}
                    color="success"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>
    </Paper>
  );
}

export default GlobalInventoryFilter;
